<!-- START HEADER-->
<header class="header" app-pet-header></header>
<!-- END HEADER-->

<!-- START SIDEBAR-->
<nav class="page-sidebar" id="sidebar" app-pet-sidbar></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper">
    <router-outlet></router-outlet>
    <!-- <div app-banner></div> -->
    <footer class="page-footer" app-pet-footer></footer>
</div>

